import { __awaiter } from "tslib";
import Vue from 'vue';
export default Vue.extend({
    name: 'buddyApiKeysCreate',
    data: () => {
        return {
            errors: [],
            loading: false
        };
    },
    props: {
        slotData: {
            required: false
        }
    },
    methods: {
        createBuddyApiKey() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.loading = true;
                    const response = yield this.services.buddy.plugBuddy();
                    yield this.slotData.updateDataFn();
                    if (response.status === 200) {
                        this.$store.commit('popupModule/setClosed');
                    }
                    else {
                        this.errors = response.errors;
                    }
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                    this.loading = false;
                }
            });
        }
    }
});
